import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'clock-icon',
  templateUrl: './clock-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClockIconComponent {}
